module.exports = __webpack_public_path__ + "static/hero_tablet-ab1ef4d957609a4c5c4bcfa88058c496.svg";